<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Lista de Atributos</h1>
    <div class="results" v-if="attributes">
      <div class="results__element" v-for="(attribute, index) in attributes" :key="index">
        <div class="results__info">
          <h2 class="results__title" v-text="attribute.name_es"></h2>
          <p v-if="attribute.name_en" class="results__text" v-text="attribute.name_en"></p>
          <p v-if="attribute.attr_type_name" class="results__text">Tipo: {{attribute.attr_type_name}}</p>
        </div>
        <div class="results__actions">
          <button @click.prevent="$parent.$emit('view', attribute.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--view">Ver Atributo</button>
          <button @click.prevent="$parent.$emit('edit', attribute.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--edit">Editar Atributo</button>
          <button @click.prevent="deleteAttribute(attribute.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--delete">Borrar Atributo</button>
        </div>
      </div>
    </div>
    <div class="information" v-else>
      <p class="information__text">No se encontraron resultados</p>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import confirmation from '@/components/layout/confirmation'
export default {
  props: {
    filters: {
      type: String,
      required: false,
      default: function () {
        return ''
      }
    }
  },
  mixins: [
    httpService
  ],
  components: {confirmation},
  data: function () {
    return {
      attributeId: null,
      attributes: null,
      confirm: false
    }
  },
  created: function () {
    this.getAttributes()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    filters: function () {
      this.getAttributes()
    },
    '$store.state.elementChanged': function () {
      this.getAttributes()
    }
  },
  methods: {
    getAttributes: function () {
      let httpRequest = {
        params: '?' + this.filters,
        module: 'attributes'
      }
      this.get(httpRequest)
        .then(
          attributes => {
            this.attributes = attributes.data
          }
        ).catch(
          () => {
            this.attributes = null
          }
        )
    },
    deleteAttribute: function (id) {
      this.confirm = true
      this.attributeId = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        params: '',
        module: 'attributes'
      }
      this.delete(this.attributeId, httpRequest)
        .then(
          response => {
            this.getAttributes()
            this.$store.commit('notificate', {
              title: 'ATRIBUTO BORRADO',
              text: 'El atributo ha sido borrado correctamente',
              type: 'success'
            })
          }
        ).catch (
          error => {
            this.$store.commit('notificate', {
              title: 'ATRIBUTO NO BORRADO',
              text: 'No se pudo borrar el atributo seleccionado, por favor intente más tarde',
              type: 'warn'
            })
          }
        )
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/attributes/list.vue